import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';
// import {
//   authContext
// } from '../../config/adalConfig';

export const CURRENT_USER_REQUEST = 'CURRENT_USER_REQUEST';
export const CURRENT_USER_SUCCESS = 'CURRENT_USER_SUCCESS';
export const CURRENT_USER_FAILURE = 'CURRENT_USER_FAILURE';
export const CURRENT_USER_LOG_OUT = 'CURRENT_USER_LOG_OUT';

export const CHANGE_LOCATION = 'CHANGE_LOCATION';

export const USER_UPLOAD_FILES_REQUEST = 'USER_UPLOAD_FILES_REQUEST';
export const USER_UPLOAD_FILES_SUCCESS = 'USER_UPLOAD_FILES_SUCCESS';
export const USER_UPLOAD_FILES_FAILURE = 'USER_UPLOAD_FILES_FAILURE';

export const USER_GET_FILE_REQUEST = 'USER_GET_FILE_REQUEST';
export const USER_GET_FILE_SUCCESS = 'USER_GET_FILE_SUCCESS';
export const USER_GET_FILE_FAILURE = 'USER_GET_FILE_FAILURE';

export const CSS_UPDATE_REQUEST = 'CSS_UPDATE_REQUEST';
export const CSS_UPDATE_SUCCESS = 'CSS_UPDATE_SUCCESS';
export const CSS_UPDATE_FAILURE = 'CSS_UPDATE_FAILURE';

export const TENANT_ASSET_REQUEST = 'TENANT_ASSET_REQUEST';
export const TENANT_ASSET_SUCCESS = 'TENANT_ASSET_SUCCESS';
export const TENANT_ASSET_FAILURE = 'TENANT_ASSET_FAILURE';

export const TENANT_ID_CHANGE = 'TENANT_ID_CHANGE';

export function requestUserInfo() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/current`,
      method: 'GET',
      types: ['CURRENT_USER_REQUEST', 'CURRENT_USER_SUCCESS', 'CURRENT_USER_FAILURE']
    }
  };
}

export function logout(msg = null) {
  // localStorage.clear(); // @todo move from here
  // authContext.logOut();

  const nps = localStorage.getItem('telemetry.nps-form');
  localStorage.clear();
  if (nps) {
    localStorage.setItem('telemetry.nps-form', nps);
  }

  return {
    type: CURRENT_USER_LOG_OUT,
    msg
  };
}

export function changeLocation(id) {
  return {
    type: CHANGE_LOCATION,
    id
  };
}

export function uploadUserFiles(userId, htmlFiles = []) {
  const data = new FormData();
  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userId}/photo`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['USER_UPLOAD_FILES_REQUEST', 'USER_UPLOAD_FILES_SUCCESS', 'USER_UPLOAD_FILES_FAILURE']
    },
  };
}

export function getUserFile(userId, fileName) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${userId}/photo/${fileName}`,
      method: 'GET',
      headers: {},
      types: [
        'USER_GET_FILE_REQUEST',
        {
          type: 'USER_GET_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'USER_GET_FILE_FAILURE']
    },
  };
}

export function updateCss(id, css) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/asset/${id}`,
      method: 'PUT',
      body: JSON.stringify(css),
      types: ["CSS_UPDATE_REQUEST", "CSS_UPDATE_SUCCESS", "CSS_UPDATE_FAILURE"]
    }
  }
}

export function requestTenantAsset(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/tenant/asset?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'TENANT_ASSET_REQUEST',
        {
          type: 'TENANT_ASSET_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'TENANT_ASSET_FAILURE']
    }
  };
}

export function changeTenant(id) {
  localStorage.setItem('tenant', id);
  return {
    type: TENANT_ID_CHANGE,
    id
  };
}



// WEBPACK FOOTER //
// ./src/store/current-user/CurrentUserActions.js